module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h2', [_c('span', {
    staticClass: "h2-inner"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "firstInSection"
  }, [_vm._v("So they’re on the Turtle Island. For Mav, whose mad mind has no boundaries, time is just another place, and this place just another time in the seamless flow of what she knows is real. By the Christian calendar, which Corban has lost track of anyway, and which pertains an ocean away, it’s the year 993. To Miska, who knows nothing but his time and his place, it is the war season, summer. For his people, the Wolves, the men in their lodges, the women in their gardens, the medicine woman Epashti, and the child Ahanton, it is the time of Miska’s being sachem, which began ten summers ago when he drove the white men into the sea.")]), _vm._v(" "), _c('p', [_vm._v("All the white men but Corban Loosestrife, who is still here. Who is still trying to break his father’s curse to find some way to go home.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0